"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function StatCard({
  bgColor,
  Icon,
  iconColor,
  value,
  caption
}) {
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: bgColor,
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: 3
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    sx: {
      color: iconColor
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    fontWeight: 700,
    variant: "h5"
  }, value !== undefined ? value : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, caption));
}
var _default = exports.default = StatCard;